// theme.js
import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  typography: {
    h1: {
      fontWeight: 700,
      fontSize: "2.5rem", // 40px - Accessible minimum, strong presence
      lineHeight: 1.2, // Tight for impact, readable
      marginBottom: "1.5rem", // Good breathing room
      "@media (min-width:600px)": {
        fontSize: "3rem", // 48px - Scales nicely for tablets
        marginBottom: "2rem",
      },
      "@media (min-width:900px)": {
        fontSize: "3.5rem", // 56px - Desktop hero size, not overwhelming
        marginBottom: "2rem",
      },
    },
  },
});

export default theme;
